require('./expandable.scss');

var pannelCollapse = $('.panel-collapse');

pannelCollapse.on('show.bs.collapse hide.bs.collapse', function(e){
    $('.collapse-control', e.target.parentNode).toggle();
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/expandable/expandable.js
// module id = 99
// module chunks = 0 1 4 5 6 10 13 16 19 21 28